<template>
  <div v-if="!mobile">
    <div class="details" style="overflow-y: scroll" v-bind:style="leaderboardheight">
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>NAME</th>
            <th v-if="!staggeredStart">DISTANCE</th>
            <th v-else>SPEED</th>
            <th>TIME</th>
            <th> </th>
            <th v-for="cp in checkpoints">{{cp.checkpoint_name}}</th>
          </tr>
        </thead>
        <tbody id="leaderbody1">
          <tr v-for="athlete in data" :key="athlete.race_athlete_id">
            <td v-on:click="log(athlete)"><span class="position">{{athlete.position}}</span></td>
            <td v-if="athlete.first_name" v-on:click="log(athlete)"><img v-if="athlete.country_code" v-bind:src="getFlag(athlete)"> {{athlete.first_name}} {{athlete.last_name}}</td>
            <td v-else-if="athlete.team_name" v-on:click="log(athlete)"><img v-if="athlete.country_code" v-bind:src="getFlag(athlete)"> {{athlete.team_name}}</td>
            <td v-if="!staggeredStart" v-on:click="log(athlete)" style="text-align: right">{{ distance(athlete) }}</td>
            <td v-else v-on:click="log(athlete)" style="text-align: right">{{ speed(athlete) }}</td>
            <td v-on:click="log(athlete)" style="text-align: center" class="finisho">{{time(athlete)}}</td>
            <td v-on:click="toggleFavourite(athlete)" class="fav">
              <favIcon v-if="athlete.name" v-bind:gender="athlete.gender"
                       v-bind:aid="athlete.athlete_id"/>
             <favIcon v-else-if="athlete.team_name" v-bind:gender="athlete.gender"
                      v-bind:aid="athlete.team_id"/>
            </td>
            <td v-for="cp in athlete.checkpoints">{{toHHMMSS(cp)}}</td>
          </tr>
          <infinite-loading @infinite="infiniteHandler"><span slot="no-more"></span></infinite-loading>
        </tbody>
      </table>
    </div>
  </div>
</template>
<style>
.details table {
	width: 100%;
	font-family: "roboto";
}
.details table thead{
	border-top: 1px solid black;
	border-bottom: 1px solid black;
	font-family: "Oswald-Regular";

}
.details table th{
	padding: 8px 5px ;
}
.details table td{
	padding: 5px ;
}
.details {
	background-color: #242f36;
}

</style>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import favIcon from './favicon'
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      selectedCat: 'All Categories',
      runningTime: {},
      data: []
    }
  },
  components: {
    favIcon,
    InfiniteLoading
  },
  mounted () {
    setInterval(this.updateDateTime, 1000)
  },
  watch: {
    getAthletes: function () {
      this.$store.dispatch('createCategories')
    },
    selectedCat: function () {
      this.$store.dispatch('loadSelectedCat', this.selectedCat)
    }
  },
  computed: {
    ...mapGetters({
      searchTerm: 'search',
      mobile: 'mobile',
      category: 'selectedCat',
      categories: 'categories',
      favourites: 'favourites',
      getAthletes: 'athletes',
      starttime: 'starttime',
      currentTime: 'currentTime',
      sortedAthletes: 'sortedAthletes',
      focusedRace: 'focusedRace',
      checkpoints: 'checkpoints',
      staggeredStart: 'staggeredStart'
    }),
    leaderboardheight: function () {
      let h = window.innerHeight - 70 - 58 - 36 - 36 - 53 - 15
      return {
        height: h + 'px'
      }
    }
  },
  methods: {
    updateDateTime () {
      for (var key in this.getAthletes) {
        let time = moment().unix() - moment.utc(this.getAthletes[key].race_start).unix()
        let dur = moment.duration(time, 'seconds')
        this.$set(this.runningTime, key, Math.floor(dur.asHours()) + ':' + ((dur.minutes() < 10) ? '0' + dur.minutes() : dur.minutes()))
      }
    },
    infiniteHandler ($state) {
      const temp = []
      for (let i = this.data.length; i <= this.data.length + 20; i++) {
        if (i < this.sortedAthletes.length) {
          temp.push(this.sortedAthletes[i])
        } else {
          $state.complete()
        }
      }
      this.data = this.data.concat(temp)
      $state.loaded()
    },
    cptime: function (cp, ath) {
      if (typeof (ath.checkpoints[cp.checkpoint_id]) !== 'undefined') {
        return this.toHHMMSS(ath.checkpoints[cp.checkpoint_id])
      } else {
        return ''
      }
    },
    distance: function (ath) {
      if (parseInt(ath.isFinished) === 1 || (typeof (ath.status) === 'undefined') || ath.status === null) {
        return (ath.properties.distance / 1000.0).toFixed(1) + ' km'
      } else {
        return '-'
      }
    },
    speed (ath) {
      if (parseInt(ath.isFinished) === 1) {
        return (ath.distance / 1000.0).toFixed(1) + ' km'
      } else if ((typeof (ath.status) === 'undefined') || ath.status === null) {
        return ath.speed + ' km/h'
      } else {
        return '-'
      }
    },
    time: function (ath) {
      if (parseInt(ath.isFinished) === 1) {
        return this.toHHMMSS(ath.duration)
      } else if ((typeof (ath.status) === 'undefined') || ath.status === null) {
        return this.runningTime[ath.race_athlete_id]
      } else if (ath.status === '2') {
        return ' WD '
      } else if (ath.status === '3') {
        return ' DNS '
      }
    },
    getFlag: function (ath) {
      return ath.country_code === null ? '' : 'https://app.sportraxs.com/images/svg/' + ath.country_code.toLowerCase() + '.svg'
    },
    log: function (ath) {
      if (this.mobile) {
        this.$router.push({name: 'mathlete', params: { id: ath.id }})
      } else {
        this.$router.push({name: 'athlete', params: { id: ath.id }})
      }
    },
    toggleFavourite: function (ath) {
      if (typeof (ath.id) !== 'undefined') {
        let index = this.favourites.indexOf(ath.id)
        if (index > -1) {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Athlete remove: ' + ath.id, label: 'Loaded', value: ''})
          this.$store.dispatch('removeFavourite', ath.id)
        } else {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Athlete add: ' + ath.id, label: 'Loaded', value: ''})
          this.$store.dispatch('addFavourite', ath.id)
        }
      } else if (typeof (ath.team_id) !== 'undefined') {
        let index = this.favourites.indexOf(ath.team_id)
        if (index > -1) {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Team remove: ' + ath.team_id, label: 'Loaded', value: ''})
          this.$store.dispatch('removeFavourite', ath.team_id)
        } else {
          this.$ma.trackEvent({category: 'Click', action: 'Favourite Team add: ' + ath.team_id, label: 'Loaded', value: ''})
          this.$store.dispatch('addFavourite', ath.team_id)
        }
      }
    },
    toHHMMSS: function (secs) {
      var secNum = parseInt(secs, 10) // don't forget the second param
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - (hours * 3600)) / 60)
      var seconds = secNum - (hours * 3600) - (minutes * 60)
      if ((minutes < 10)) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      if (hours < 10) {
        hours = '' + hours
      }
      var time
      if (hours === '0') {
        time = '0:' + minutes // + seconds
      } else {
        time = hours + ':' + minutes // + ':' + seconds
      }
      return time
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/details.vue